import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor, AgComboBoxEditor, } from 'jk-service';
import { Taxwd } from './Taxwd-angular';

export const TaxWd090List = [{ id: "1", name: "傳送" }, { id: "2", name: "接收" }]; // 傳送或接收

@Injectable({
  providedIn: 'root'
})
export class TaxwdServicePkg extends JkEntityV2 {
  TaxWd090List = TaxWd090List;


  constructor() {
    super();
    this.linkMasterFields = 'WD001=WC001,WD002=WC002';
    this.defaultItem = new Taxwd();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      WD001: '發票號碼', WD002: '訊息類別', WD003: '申報年月', WD004: '序號', WD005: '發票起號', WD006: '發票迄號', WD007: '品名', WD008: '數量', WD009: '單價', WD010: '金額', WD011: '備註', WD012: '單位', WD013: '相關號碼', WD014: '營業稅額', WD015: '流水號', WD016: '原幣金額', WD017: '銷貨來源單別', WD018: '銷貨來源單號', WD019: '結帳來源單別', WD020: '結帳來源單號', WD090: '傳送或接收'
    };

    this.fieldNames = 'WD001,WD002,WD003,WD004,WD005,WD006,WD007,WD008,WD009,WD010,WD011,WD012,WD013,WD014,WD015,WD016,WD017,WD018,WD019,WD020,WD090';
    this.fieldLengths = { WD001: 20, WD002: 5, WD003: 6, WD004: 4, WD005: 10, WD006: 10, WD007: 120, WD008: 11.3, WD009: 21.6, WD010: 12, WD011: 255, WD012: 6, WD013: 20, WD014: 12, WD015: 7, WD016: 21.6, WD017: 4, WD018: 20, WD019: 4, WD020: 20, WD090: 1 };
    this.columnDefs = [
      { field: "WD012", headerName: "單位", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "WD090", headerName: "傳送或接收", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgComboBoxEditor, cellRendererParams: { list: this.TaxWd090List }, },
      { field: "WD020", headerName: "結帳來源單號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WD019", headerName: "結帳來源單別", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WD018", headerName: "銷貨來源單號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WD017", headerName: "銷貨來源單別", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WD016", headerName: "原幣金額", headerTooltip: "", width: 243, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WD015", headerName: "流水號", headerTooltip: "", width: 126, cellDataType: "text", },
      { field: "WD014", headerName: "營業稅額", headerTooltip: "", width: 166, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WD013", headerName: "相關號碼", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WD001", headerName: "發票號碼", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "WD011", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "WD010", headerName: "金額", headerTooltip: "", width: 166, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WD009", headerName: "單價", headerTooltip: "", width: 243, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WD008", headerName: "數量", headerTooltip: "", width: 160, cellDataType: "number", cellStyle: { 'text-align': 'right' }, },
      { field: "WD007", headerName: "品名", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "WD006", headerName: "發票迄號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WD005", headerName: "發票起號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WD004", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", },
      { field: "WD003", headerName: "申報年月", headerTooltip: "", width: 118, cellDataType: "text", },
      { field: "WD002", headerName: "訊息類別", headerTooltip: "", width: 110, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'TAXWD';
    this.isSys = false;
    this.sqlSelect = `SELECT TAXWD.*  FROM TAXWD`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY WD001,WD002,WD003,WD004,WD090`;
    this.keyFields = ['WD001', 'WD002', 'WD003', 'WD004', 'WD090'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['WD001', 'WD002', 'WD003', 'WD004', 'WD090'];
    this.seqField = 'WD004';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Taxwd): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Taxwd): Promise<Taxwd> {
    await super.newRecord(newItem);
    return newItem;
  }




}

